export interface HamburgersProps {
  onClick?: () => void;
  className?: string;
}

export const Hamburger = ({ onClick, className }: HamburgersProps) => (
  <button
    aria-label="Toggle menu"
    className={`group h-14 w-14 ${className}`}
    id="hamburger"
    onClick={onClick}
  >
    <div className="-translate-x-1/2 -translate-y-1/2 absolute top-1/2 left-6 block w-4 transform transition-all">
      <span className="-translate-y-2 absolute block h-0.5 w-6 bg-current text-neutral-darkest transition-all ease-in-out group-focus:top-2 group-focus:rotate-45" />
      <span className="absolute block h-0.5 w-6 bg-current text-neutral-darkest transition-all ease-in-out group-focus:opacity-0" />
      <span className="group-focus:-rotate-45 group-focus:-top-2 absolute block h-0.5 w-6 translate-y-2 bg-current text-neutral-darkest transition-all ease-in-out" />
    </div>
  </button>
);
